<!-- 货单样式设置 -->
<template>
  <el-form ref="form" :model="form" label-width="80px" size="mini">
    <div class="row-wrap">
      <span v-for="(ticketSetting, idx) in form.ticketSettings" :key="idx">
          <div style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);padding:10px 10px;">
              <el-row>
                  <el-col :xs="24" :sm="12" :md="6">
                      <el-form-item :label="msg('设置名')">
                          <el-input v-model="ticketSetting.name"
                                    :placeholder="msg('请输入名称，方便选择')"></el-input>
                      </el-form-item>
                  </el-col>
              </el-row>
              <div>
                  <el-checkbox
                      border size="mini" class="pts-checkbox"
                      v-model="ticketSetting.detail" :label="msg('拣货单详情')">
                  </el-checkbox>
                  <el-checkbox v-show="ticketSetting.detail"
                               border size="mini" class="pts-checkbox"
                               v-model="ticketSetting.detailName" :label="msg('拣货单货物品名')">
                  </el-checkbox>
                  <el-checkbox v-show="ticketSetting.detail"
                               border size="mini" class="pts-checkbox"
                               v-model="ticketSetting.detailCode" :label="msg('拣货单货物编号')">
                  </el-checkbox>
                  <el-checkbox v-show="ticketSetting.detail"
                               border size="mini" class="pts-checkbox"
                               v-model="ticketSetting.detailShelfCode" :label="msg('拣货单架位号')">
                  </el-checkbox>
                  <el-checkbox v-show="ticketSetting.detail"
                               border size="mini" class="pts-checkbox"
                               v-model="ticketSetting.detailTitle" :label="msg('拣货单描述')">
                  </el-checkbox>
                  <el-checkbox v-show="ticketSetting.detail"
                               border size="mini" class="pts-checkbox"
                               v-model="ticketSetting.detailSpec" :label="msg('拣货单规格')">
                  </el-checkbox>
                  <el-checkbox v-show="ticketSetting.detail"
                               border size="mini" class="pts-checkbox"
                               v-model="ticketSetting.detailStoreType" :label="msg('拣货单仓储类型')">
                  </el-checkbox>
                  <el-checkbox
                      border size="mini" class="pts-checkbox"
                      v-model="ticketSetting.detailSku" :label="msg('SKU&货号')">
                  </el-checkbox>
              </div>
              <div>
                  <el-checkbox
                      border size="mini" class="pts-checkbox"
                      v-model="ticketSetting.detailPkg" :label="msg('拣货单包号')">
                  </el-checkbox>
                  <el-checkbox
                      border size="mini" class="pts-checkbox"
                      v-model="ticketSetting.detailDate" :label="msg('拣货单日期')">
                  </el-checkbox>
                  <el-checkbox
                      border size="mini" class="pts-checkbox"
                      v-model="ticketSetting.detailRemark1" :label="msg('拣货单报单备注')">
                  </el-checkbox>
                  <el-checkbox
                      border size="mini" class="pts-checkbox"
                      v-model="ticketSetting.detailRemark2" :label="msg('拣货单货单备注')">
                  </el-checkbox>
                  <el-checkbox
                      border size="mini" class="pts-checkbox"
                      v-model="ticketSetting.shopSellerMsg" :label="msg('拣货单买家留言')">
                  </el-checkbox>
                  <el-checkbox
                      border size="mini" class="pts-checkbox"
                      v-model="ticketSetting.pkgType" :label="msg('拣货单打包類型')">
                  </el-checkbox>
                  <el-checkbox
                      border size="mini" class="pts-checkbox"
                      v-model="ticketSetting.note" :label="msg('拣货单订单备注')">
                  </el-checkbox>
                  <el-checkbox
                      border size="mini" class="pts-checkbox"
                      v-model="ticketSetting.shopName" :label="msg('拣货单店铺名')">
                  </el-checkbox>
                  <el-checkbox
                      border size="mini" class="pts-checkbox"
                      v-model="ticketSetting.ownerName" :label="msg('归属人')">
                  </el-checkbox>
                  <el-checkbox
                      border size="mini" class="pts-checkbox"
                      v-model="ticketSetting.receiver" :label="msg('收件人')">
                  </el-checkbox>
                  <el-checkbox
                      border size="mini" class="pts-checkbox"
                      v-model="ticketSetting.expGoodType" :label="msg('货物类型')">
                  </el-checkbox>
                  <el-checkbox
                      border size="mini" class="pts-checkbox"
                      v-model="ticketSetting.orderPlatform" :label="msg('订单卖场')">
                  </el-checkbox>
                  <el-checkbox
                      border size="mini" class="pts-checkbox"
                      v-model="ticketSetting.preOrderCode" :label="msg('抬头单号')">
                  </el-checkbox>
                  <el-checkbox
                      border size="mini" class="pts-checkbox"
                      v-model="ticketSetting.amtOrder" :label="msg('订单金额')">
                  </el-checkbox>
                  <el-checkbox
                      border size="mini" class="pts-checkbox"
                      v-model="ticketSetting.goodsAmount" :label="msg('货值')">
                  </el-checkbox>
                  <el-checkbox
                      border size="mini" class="pts-checkbox"
                      v-model="ticketSetting.groupName" :label="msg('企业名称')">
                  </el-checkbox>
              </div>
              <div>
                  <el-switch v-model="ticketSetting.disabled"
                             inactive-text="是否默认" @click.native="setDefault(idx, 'ticketSettings')"
                             :active-value="1" :inactive-value="0"
                             active-color="#13ce66" inactive-color="#ff4949">
                  </el-switch>
                  <el-link style="margin-left:20px;" icon="el-icon-delete"
                           type="danger" :underline="false"
                           @click="form.ticketSettings.splice(idx, 1);">{{ msg('删除') }}</el-link>
              </div>
              <div class="page-tpl">
                  <template>
                      <preview-tpl :ticketSetting="ticketSetting"></preview-tpl>
                  </template>
              </div>
          </div>
      </span>
      <div style="text-align:center;">
        <el-button type="primary" @click="addTs()" plain size="mini">添加更多</el-button>
      </div>
      <el-button type="primary" size="mini" @click="update"><i class="el-icon-check"></i><span>{{
          msg('确定')
        }}</span>
      </el-button>
    </div>
  </el-form>
</template>

<script>
import PreviewTpl from "./PrintPageTplPreview.vue";
export default {
  name: "UserSettingInvoiceStyle",
  components:{
    PreviewTpl : PreviewTpl,
  },
  data() {
    return {
      xgroup: 'TPSETTING', //货单打印group
      form: {
        ticketSettings: [], //货单打印设置
      }
    }
  },
  mounted() {
    this.getSettings();
  },
  methods: {
    getSettings() {
      var _this = this;
      this.$axios.get(this.$kit.api.user.settingList + "?xgroup=" + this.xgroup)
          .then((result) => {
            if (result.status) {
              this.buildViewData(result.data); //构建设置对象
            }
          });
    },
    buildViewData(data){
      var _this = this;
      _this.form.ticketSettings = [];

      if(data && data.length > 0){
        let tp = data;  //电子秤数据
        //货单打印页面数据
        if(tp.length>0){
          tp.forEach(a => {
            if(a.xvalue){
              let set = JSON.parse(a.xvalue);
              let ticket = {
                id: a.id,
                disabled: a.disabled,
                owner: a.owner,
                name: set.name,
                invoice: set.invoice,
                invoiceHead: set.invoiceHead,
                invoiceCompany: set.invoiceCompany,
                invoiceBarCode: set.invoiceBarCode,
                invoiceInfo: set.invoiceInfo,
                invoiceCode: set.invoiceCode,
                invoiceSender: set.invoiceSender,
                invoiceReceiver: set.invoiceReceiver,
                invoiceTel: set.invoiceTel,
                invoiceAddr: set.invoiceAddr,
                pkgType: set.pkgType,

                invoiceTable: set.invoiceTable,
                invoiceTableName: set.invoiceTableName,
                invoiceTableQty: set.invoiceTableQty,
                invoiceTablePrice: set.invoiceTablePrice,
                invoiceTableAmount: set.invoiceTableAmount,

                detail: set.detail,
                detailCode: set.detailCode,
                detailShelfCode: set.detailShelfCode,
                erweima: set.erweima,
                tiaoma: set.tiaoma,
                detailName: set.detailName,
                detailTitle: set.detailTitle,
                detailSpec: set.detailSpec,
                detailStoreType: set.detailStoreType,
                detailPkg: set.detailPkg,
                detailDate: set.detailDate,
                detailRemark1: set.detailRemark1,
                detailRemark2: set.detailRemark2,
                note: set.note,
                shopSellerMsg: set.shopSellerMsg,
                shopName: set.shopName,
                ownerName:set.ownerName,
                receiver:set.receiver,
                expGoodType:set.expGoodType,
                orderPlatform:set.orderPlatform,
                preOrderCode:set.preOrderCode,
                amtOrder:set.amtOrder,
                goodsAmount:set.goodsAmount,
                detailSku:set.detailSku,
              }
              _this.form.ticketSettings.push(ticket);
            }
          });
        }

      }
    },
    addTs(){
      this.form.ticketSettings.push({
        id: null,
        disabled:0,
        owner: null,
        name: null,
        invoice: true,
        invoiceHead: true,
        invoiceCompany: true,
        invoiceBarCode: true,
        invoiceInfo: true,
        invoiceCode: true,
        invoiceSender: true,
        invoiceReceiver: true,
        invoiceTel: true,
        invoiceAddr: true,
        pkgType: true,

        invoiceTable: true,
        invoiceTableName: true,
        invoiceTableQty: true,
        invoiceTablePrice: true,
        invoiceTableAmount: true,
        erweima: true,
        tiaoma: true,
        detail: true,
        detailCode: true,
        detailShelfCode: true,
        detailName: true,
        detailTitle: true,
        detailSpec: true,
        detailStoreType:false,
        detailPkg: true,
        detailDate: true,
        detailRemark1: true,
        detailRemark2: true,
        note:true,
        shopSellerMsg: true,
        shopName:false,
        ownerName:false,
        receiver:false,
        expGoodType:false,
        orderPlatform:false,
        preOrderCode:false,
        amtOrder:false,
        goodsAmount:false,
        detailSku:false,
      })
    },
    update() {
      let datas = [];
      //构建货单打印设置
      let dis = false;
      for (let i = 0; i < this.form.ticketSettings.length; i++) {
        let e = this.form.ticketSettings[i];
        if (!e.name) {
          this.$message(this.msg('请输入货单设置名称'));
          return;
        }
        let key = this.xgroup + i;
        datas.push({
          id: e.id,
          disabled: e.disabled,
          xkey: key,
          xlabel: e.name,
          xvalue: JSON.stringify(e),
          owner: e.owner ? e.owner : null,
          xgroup: this.xgroup
        })
        if (!dis && e.disabled == 1) {
          dis = true;
        }
      }
      //如果没有设置默认值，则选择第一条作为默认值
      if (!dis && this.form.ticketSettings.length > 0 && this.datas && this.datas.length > 0) {
        let ts = this.datas.find(d => d.xgroup == this.xgroup);
        if (ts) {
          ts.disabled = 1;
        }
      }

      var _this = this;
      _this.$axios.post(_this.$kit.api.user.settingUpdate + "?xgroup=" + this.xgroup, datas).then((result) => {
        _this.$message(result.msg)
      });
    }
  }
}
</script>

<style scoped>

</style>